// CommonSelect.js
import { Select } from "antd";
import React from "react";

const CommonSelect = ({ field, form, options, placeholder, ...rest }) => (
  <Select
    {...field}
    {...rest}
    placeholder={placeholder}
    className="custom-ant-select"
    options={options}
    dropdownStyle={{ zIndex: 1080 }}
    showSearch
    allowClear
    filterOption={(input, option) =>
      option.label.toLowerCase().includes(input.toLowerCase())
    }
    value={field.value ?? null}  // ensure null instead of undefined
    onChange={(value) => form.setFieldValue(field.name, value || null)} // force null
    onBlur={() => form.setFieldTouched(field.name, true)}
  />
);

export default CommonSelect;
